import BusinessReportService from '../services/business-report-service';

export const businessReports = {
  namespaced: true,
  state: {
    exports: null,
  },
  actions: {
    getAll({ commit }) {
      // commit('setIsBusy', true, { root: true });
      return BusinessReportService.getAll().then(
        (result) => {
          commit('setIsBusy', false, { root: true });
          commit('setExports', result.model);
          return Promise.resolve(result);
        },
        (error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        }
      );
    },
    get({ commit }, id) {
      commit('setIsBusy', true, { root: true });
      return BusinessReportService.get(id)
        .then((result) => {
          commit('setIsBusy', false, { root: true });
          const { message } = result;
          return Promise.resolve(message);
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
    delete({ commit }, id) {
      commit('setIsBusy', true, { root: true });
      return BusinessReportService.delete(id)
        .then((result) => {
          commit('setIsBusy', false, { root: true });
          const { message } = result;
          return Promise.resolve(message);
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
    deletePending({ commit }, id) {
      commit('setIsBusy', true, { root: true });
      return BusinessReportService.deletePending(id)
        .then((result) => {
          commit('setIsBusy', false, { root: true });
          const { message } = result;
          return Promise.resolve(message);
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
    post({ commit }, payload) {
      commit('setIsBusy', true, { root: true });
      return BusinessReportService.post(payload)
        .then((result) => {
          commit('setIsBusy', false, { root: true });
          const { message } = result;
          return Promise.resolve(message);
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
    download({ commit }, id) {
      commit('setIsBusy', true, { root: true });
      return BusinessReportService.download(id)
        .then((result) => {
          commit('setIsBusy', false, { root: true });
          return Promise.resolve(result);
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
  },
  mutations: {
    setExports(state, searchResult) {
      state.exports = searchResult;
    },
  },
};
